// PortfolioLoader.js
import React from 'react';
import PageContainer from '../pages/PageContainer';
import GameSideBar from '../Games/GameSideBar';

const PortfolioLoader = () => {
  return (
    <>

        <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="flex items-center justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div className="flex items-center justify-center fixed z-50 inset-0 overflow-y-auto">
          <div className="w-full flex items-center justify-center pt-4 pb-20 text-center sm:block sm:p-0">
          <div className="flex items-center justify-center">
            <div
              style={{
                border: '4px solid rgba(0, 0, 0, 0.1)', // Light gray border
                borderTop: '4px solid green',        // Blue spinner color
                borderRadius: '50%',                  // Circular shape
                width: '40px',                        // Size of spinner
                height: '40px',                       // Size of spinner
                animation: 'spin 1s linear infinite', // Smooth rotation animation
              }}
            ></div>

          </div>

          </div>
        </div>
      </div>
    </div>
    </>
  );
};

const styles = {
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px',
    textAlign: 'center',
  },
  button: {
    margin: '10px',
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
  }

};

export default PortfolioLoader;
